<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="第几集" prop="currentIndex">
          <el-input v-model="dataForm.currentIndex" placeholder="第几集"></el-input>
      </el-form-item>
          <el-form-item label="影片ID" prop="vid">
          <el-input v-model="dataForm.vid" placeholder="影片ID"></el-input>
      </el-form-item>
          <el-form-item label="弹幕内容" prop="text">
          <el-input v-model="dataForm.text" placeholder="弹幕内容"></el-input>
      </el-form-item>
          <el-form-item label="弹幕颜色" prop="color">
          <el-input v-model="dataForm.color" placeholder="弹幕颜色"></el-input>
      </el-form-item>
          <el-form-item label="第几秒" prop="time">
          <el-input v-model="dataForm.time" placeholder="第几秒"></el-input>
      </el-form-item>
          <el-form-item label="发送者ID" prop="memberCode">
          <el-input v-model="dataForm.memberCode" placeholder="发送者ID"></el-input>
      </el-form-item>
          <el-form-item label="发送时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="发送时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        currentIndex: '',
        vid: '',
        text: '',
        color: '',
        time: '',
        memberCode: '',
        createTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        currentIndex: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        vid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        text: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        color: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/barrage/barrage/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/barrage/barrage/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
